import { render } from "./FullCalendar.vue?vue&type=template&id=71a51f6b&ts=true"
import script from "./FullCalendar.vue?vue&type=script&lang=ts"
export * from "./FullCalendar.vue?vue&type=script&lang=ts"

import "./FullCalendar.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__